import JSZip from 'jszip';
import type { GraphArchivePackage } from '../../types/archive';
export async function serializeJourneyNodesArchive(pkg: GraphArchivePackage): Promise<Blob> {
  const zip = new JSZip();
  zip.file('graph.json', JSON.stringify(pkg.graphJson, null, 2));
  zip.file('media-manifest.json', JSON.stringify(pkg.mediaManifest, null, 2));
  if (pkg.configJson !== undefined) zip.file('config.json', JSON.stringify(pkg.configJson, null, 2));
  if (pkg.savegameJson !== undefined) zip.file('savegame.json', JSON.stringify(pkg.savegameJson, null, 2));
  if (pkg.archiveSignature !== undefined) zip.file('signature.json', JSON.stringify(pkg.archiveSignature, null, 2));
  const folder = zip.folder('assets');
  for (const [name, data] of Object.entries(pkg.assets)) folder?.file(name, data);
  return zip.generateAsync({ type: 'blob', compression: 'DEFLATE' });
}
